import getBasePath from '../../../../../common/functions/api-resource';

const basePath = getBasePath('usuario', 'sso/usuario');

const usuarioActions = {
  listar: { method: 'GET', url: `${basePath}?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}` },
  quantidade: { method: 'GET', url: `${basePath}/quantidade?tamanhoPagina={size}&numeroPagina={page}&filtro={filter}` },
  buscarGrupo: { method: 'GET', url: `${basePath}/{idUsuario}/grupo` },
  buscarUsuario: { method: 'GET', url: `${basePath}/{idUsuario}` },
  salvar: { method: 'PUT', url: `${basePath}` },
  inserir: { method: 'POST', url: `${basePath}` },
};

export default resource => resource(`${basePath}`, {}, usuarioActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/sso/usuario.js